<template>
  <div :class="classBlock">
    <div class="mouse">
      <div class="mouse-icon">
        <span class="mouse-wheel"></span>
      </div>
    </div>
  </div>
</template>

<script>
  // -------------------------------------------- imports dependencies

  // -------------------------------------------- imports components

  export default {
    // -------------------------------------------- init
    name: 'MouseScroll',
    // components imported
    components: {},
    // component properties
    props: {
      classNames: [] // string[]
    },

    // -------------------------------------------- components datas
    data: () => ({
      component: 'MouseScroll'
    }),

    // -------------------------------------------- computed properties
    computed: {
      /**
      * class block formater
      */
      classBlock: function () {
        return [
          this.component,
          ...[this.classNames],
        ].filter(v => v).join(' ');
      }
    },

    // -------------------------------------------- methods
    methods: {},

    // -------------------------------------------- mounted
    mounted: function () {},

    // -------------------------------------------- destroy
    destroy: function () {}
  } 
</script>

<style lang="scss">
    @import '../styles/reference';

    // Component name
    $COMPONENT: 'MouseScroll';
    .MouseScroll {
        // --------------------------------------------------------------------- CONFIG

        // --------------------------------------------------------------------- BLOCK

        // --------------------------------------------------------------------- ELEMENTS
        .mouse{
          margin: 50px auto;
          width: 100px;
        }
        .mouse-icon{
          width: 25px;
          height: 45px;
          border: 2px solid white;
          border-radius: 15px;
          cursor: pointer;
          position: relative;
          text-align: center;
          margin: auto;
        }
        .mouse-wheel{
          height: 6px;
          margin: 2px auto 0;
          display: block;
          width: 3px;
          background-color: white;
          border-radius: 50%;
          -webkit-animation: 1.6s ease infinite wheel-up-down;
          -moz-animation: 1.6s ease infinite wheel-up-down;
          animation: 1.6s ease infinite wheel-up-down;
        }
        @-webkit-keyframes wheel-up-down {
          0% {
              margin-top: 2px;
              opacity: 0;
          }
          30% {
              opacity: 1;
          }
          100% {
              margin-top: 20px;
              opacity: 0;
          }
        }
        @-moz-keyframes wheel-up-down {
          0% {
              margin-top: 2px;
              opacity: 0;
          }
          30% {
              opacity: 1;
          }
          100% {
              margin-top: 20px;
              opacity: 0;
          }
        }
        @keyframes wheel-up-down {
          0% {
              margin-top: 2px;
              opacity: 0;
          }
          30% {
              opacity: 1;
          }
          100% {
              margin-top: 20px;
              opacity: 0;
          }
        }

        // --------------------------------------------------------------------- MODIFIERS

        // --------------------------------------------------------------------- CHILDREN

        // --------------------------------------------------------------------- PSEUDOS

        // --------------------------------------------------------------------- PATCHES

    }

</style>

